import { render, staticRenderFns } from "./PublicOfferEn.vue?vue&type=template&id=546bdf0c&scoped=true"
import script from "./PublicOfferEn.vue?vue&type=script&lang=ts"
export * from "./PublicOfferEn.vue?vue&type=script&lang=ts"
import style0 from "./PublicOfferEn.vue?vue&type=style&index=0&id=546bdf0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bdf0c",
  null
  
)

export default component.exports